import React, { useState } from 'react';
import { FormGroup, Label } from 'reactstrap';
import KaAlert from '../Common/KaAlert';
import KaModal from '../Common/KaModal';
import { KaSelect, KaSelectOption, toKaSelectOptions } from '../Common/KaSelect';
import QueryView from '../Common/QueryView';
import SpinnerButton from '../Common/SpinnerButton';
import useDisplayMessage from '../Common/useDisplayMessage';
import { BusinessDto } from '../../requests/employee/useGetBusinesses';
import useAddBusinessIntegration from '../../requests/employee/useAddBusinessIntegration';
import useGetIntegrations from '../../requests/employee/useGetIntegrations';

interface IProps {
  business: BusinessDto;
  onHide: () => void;
  onSuccess: (message: string) => void;
}

export const AddIntegration = (props: IProps) => {
  const displayMessage = useDisplayMessage();
  const getIntegrations = useGetIntegrations();
  const [selectedIntegration, setSelectedIntegration] = useState<KaSelectOption | null>(null);

  const availableIntegrations = (getIntegrations.data ?? [])
    .filter(i => !props.business.integrations.some(existing => existing.id === i.id));

  const integrationOptions = toKaSelectOptions(availableIntegrations, "id", "name", { sortByLabel: true });

  const useAddIntegration = useAddBusinessIntegration(props.business.id, {
    onSuccess: () => props.onSuccess(`Added ${selectedIntegration?.label} to business: ${props.business.name}`),
    onError: (e) => displayMessage.fail(e.message),
  });

  const onClose = () => {
    props.onHide();
    displayMessage.clear();
  }

  return (<KaModal
    onHide={onClose}
    show={true}
    title={`Add integration to ${props.business.name}`}
    body={(<>
      <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
      <QueryView
        query={getIntegrations}
        renderData={() => availableIntegrations.length === 0
          ? <p>{props.business.name} already has every available integration.</p>
          : <FormGroup>
            <Label for="integration">Integration</Label>
            <KaSelect
              inputId="integration"
              options={integrationOptions}
              value={selectedIntegration}
              onChange={(newValue) => setSelectedIntegration(newValue as KaSelectOption | null)}
              placeholder="Select an integration..."
            />
          </FormGroup>}
      />
    </>)}
    footer={(
      <SpinnerButton
        className="btn-ghost-primary"
        disabled={!selectedIntegration}
        spinning={useAddIntegration.isLoading}
        onClick={() => selectedIntegration && useAddIntegration.request({ integrationId: selectedIntegration.value })} >
        Add
      </SpinnerButton>)
    }
  />);
}
